import React from 'react';
import { observer } from 'mobx-react';


import Notifications from '../Notifications/Notifications';
import 'url-search-params-polyfill';
import { UserContext, RootStoreContext } from '../../context';
import TippingModal from '../TippingModal/TippingModal';
import { BlogProvider } from '../../hooks/useBlog';
import { overrideStatusResponse } from '../../utils/overrideStatusResponse';
import GlobalNotification from '../GlobalNotification/GlobalNotification';
import NotificationStore from '../../store/NotificationStore';
import Routes from '../Routes/Routes';
import FullLoader from '../Loaders/FullLoader';

import {
  checkStatus,
  getActiveCampaign,
  getAnchorPortalCampaign,
  initializeGlobalSession,
} from './services';
import CampaignStore from '../../store/CampaignStore';
import PaymentStore from '../../store/PaymentStore';


@observer
class App extends React.Component {

  static contextType = RootStoreContext;

  state = {
    user: {
      userDetails: {},
      token: '',
      features: [],
    },
    isLoaded: false,
    showCookieConsent: false,
    showPremiumUpgradeBar: false,
    userPremiumExpired: false,
    activeCampaigns: [],
    anchorPortalCampaign: {},
  };

  async componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const affiliateCode = urlParams.get('_atc');
    if (affiliateCode) {
      document.cookie = `_atc=${affiliateCode}; expires=0; path=/`;
    }
    const [statusResponse, campaignResponse, anchorCampaignResponse] = await Promise.all([
      checkStatus(),
      getActiveCampaign(),
      getAnchorPortalCampaign(),
    ]);
    const { data: { data: anchorPortalCampaign } } = anchorCampaignResponse;
    const activeCampaigns = campaignResponse?.data?.data;
        const { error, data } = statusResponse;

    if (data?.data?.authenticated) {
      sessionStorage.username = data?.data?.user?.username;
      sessionStorage.token = data?.data?.user?.token;
    }

    CampaignStore.setCurrentCampaign(data?.data, activeCampaigns);
    PaymentStore.checkForPaymentFailure(urlParams, data?.data);
    const userPremiumExpired = data.data.authenticated && !data.data.user.activeSubscription;
    this.setAppState(userPremiumExpired, data?.data, activeCampaigns, anchorPortalCampaign);
    if (!error) {
      this.mergeUserDataWithTemptedUserData(data);
    }
  }

  setAppState = (userPremiumExpired, userData, activeCampaigns, anchorPortalCampaign) => {
    this.setState({
      isLoaded: true,
      activeCampaigns,
      user: userData,
      userPremiumExpired,
      anchorPortalCampaign,
      showCookieConsent: !document.cookie.includes('notify_cookie_usage=true'),
    });
  };

  mergeUserDataWithTemptedUserData = async(data) => {
    const userData = { ...data };
    await overrideStatusResponse(userData);
    this.setState({ user: userData?.data });
    if (data) {
      try {
        await initializeGlobalSession(data.data, this.context);
      } catch (e) {
        console.error('Could not initialize global presence');
      }
    }
  };

  closePremiumUpgradeBar = () => {
    this.setState({ showPremiumUpgradeBar: false });
  };

  acceptCookies = (event) => {
    event.preventDefault();
    document.cookie = 'notify_cookie_usage=true;max-age=2592000';
    this.setState({ showCookieConsent: false });
  };

  render() {
    const {
      user,
      showPremiumUpgradeBar,
      userPremiumExpired,
      activeCampaigns,
      anchorPortalCampaign,
    } = this.state;
    const { notificationMessage } = NotificationStore;

    const notificationsAvailable = !(user?.user && user?.user?.account?.anchor);

    if (!this.state.isLoaded) {
      return <FullLoader />;
    }

    return (
      <>
        <UserContext.Provider value={user}>
          <BlogProvider>
            {notificationsAvailable && <Notifications user={user} />}
            <Routes
              activeCampaigns={activeCampaigns}
              anchorPortalCampaign={anchorPortalCampaign}
              closePremiumUpgradeBar={this.closePremiumUpgradeBar}
              showPremiumUpgradeBar={showPremiumUpgradeBar}
              userPremiumExpired={userPremiumExpired}
            />
            <TippingModal user={user} />
            {notificationMessage && <GlobalNotification />}
          </BlogProvider>
        </UserContext.Provider>
      </>
    );
  }
}

export default App;
